import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface User {
    id: string;
    Name: string;
    Surname: string;
    "Address.ZipCode": string;
    "Address.City": string;
    "Address.Address": string;
    "Address.Country": string;
    "Address.StateProvince": string;
    DateOfBirth: string;
    // "1" = Donna, "2" = Uomo (convenzione GENDER). Opzionale: i profili creati
    // prima dell'introduzione del campo potrebbero non averlo.
    Gender?: string;
    EmailCommunicationAgreed: string;
    MobileCommunicationAgreed: string;
    PrivacyAgreed: string;
    ProfilingAgreed: string;
    DataSharingAgreed: string;
    MobileNumber: string;
    EmailAddress: string;
    status: string;
}

interface AuthState {
    token: string | null;
    user: User | null;

    login: (token: string, user: User) => void;
    logout: () => void;
    setUser: (user: User) => void;
    setToken: (token: string) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            token: null,
            user: null,

            login: (token: string, user: User) => {
                set({
                    token,
                    user,
                });
            },

            logout: () => {
                set({
                    token: null,
                    user: null,
                });
            },

            setUser: (user: User) => {
                set({ user });
            },

            setToken: (token: string) => {
                set({ token });
            },
        }),
        {
            name: 'auth-storage',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                token: state.token,
                user: state.user,
            }),
        }
    )
);

export const useAuth = () => {
    const store = useAuthStore();
    return {
        token: store.token,
        user: store.user,
        login: store.login,
        logout: store.logout,
        setUser: store.setUser,
        setToken: store.setToken,
    };
};

export const useUser = () => {
    return useAuthStore((state) => state.user);
};


export const useToken = () => {
    return useAuthStore((state) => state.token);
};